import React from "react";
import { AnalyticsSessionParamsContextType } from "@pepdirect/shared/types";

export const AnalyticsSessionParamsContext =
  React.createContext<AnalyticsSessionParamsContextType>({
    analyticsSessionParams: {},
  });
